<template>
  <div class="settings">
    <h1>轨迹记录后台</h1>
    <label class="switch-label">
      <span class="switch-text">记录开关</span>
      <label class="switch">
        <input type="checkbox" v-model="isSwitchOn" @change="setRecorderStatusFunction"/>
        <span class="slider"></span>
      </label>
    </label>
    <h1>微信小程序后台</h1>
    <label class="switch-label">
      <span class="switch-text">强制登录开关</span>
      <label class="switch">
        <input type="checkbox" v-model="mandatoryLogin.MandatoryLogin" @change="setMandatoryLoginFunction"/>
        <span class="slider"></span>
      </label>
    </label>
    <label class="switch-label">
      <span class="switch-text">{{ mandatoryLoginTime }}</span>
    </label>
    <button @click="changeMandatoryLoginTime" class="refresh-btn">刷新强制登录时间</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mandatoryLogin: {
        MandatoryLogin: false,
        datetime: 0,
      },//强制登陆信息
      mandatoryLoginTime: '',
      isSwitchOn: false, // 记录开关初始状态
      getRecorderStatusUrl: '/api/cartools/getRecorderStatus',
      setRecorderStatusUrl: '/api/cartools/setRecorderStatus',
      getMandatoryLoginUrl: '/api/cartools/getMandatoryLogin',
      setMandatoryLoginUrl: '/api/cartools/setMandatoryLogin',
    };
  },
  methods: {
    getMandatoryLoginFunction() {
      let that = this
      that.$ajax({
        method: 'get',
        params: {Key: 'RecorderStatus'},
        url: that.getMandatoryLoginUrl
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message);
        } else {
          const result = JSON.parse(response.data.responseData);
          this.mandatoryLogin.MandatoryLogin = result.MandatoryLogin
          this.mandatoryLogin.datetime = result.datetime
          this.mandatoryLoginTime = that.formatTimestamp(result.datetime);
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    changeMandatoryLoginTime() {
      this.mandatoryLogin.datetime = Math.floor(Date.now() / 1000);
      this.mandatoryLoginTime = this.formatTimestamp(Math.floor(Date.now() / 1000));
      this.setMandatoryLoginFunction();
    },
    setMandatoryLoginFunction() {
      const value = JSON.stringify(this.mandatoryLogin);
      let that = this
      that.$ajax({
        method: 'get',
        params: {value: value},
        url: that.setMandatoryLoginUrl
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message);
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getRecorderStatusFunction() {
      let that = this
      that.$ajax({
        method: 'get',
        params: {Key: 'RecorderStatus'},
        url: that.getRecorderStatusUrl
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message);
        } else {
          this.isSwitchOn = response.data.responseData === 'true';
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    setRecorderStatusFunction() {
      let that = this
      that.$ajax({
        method: 'get',
        params: {status: this.isSwitchOn},
        url: that.setRecorderStatusUrl
      }).then((response) => {
        if (!response.data.result) {
          that.$messagebox.alert(response.data.message);
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000) // 注意转换为毫秒
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
  },
  mounted() {
    this.getMandatoryLoginFunction()
    this.getRecorderStatusFunction()
  },
};
</script>

<style scoped>
.settings {
  padding: 20px;
  max-width: 300px;
  margin: 0 auto;
  text-align: center;
}

.switch-label {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.switch-text {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-right: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.refresh-btn {
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.refresh-btn:hover {
  background-color: #66b1ff;
}
</style>